import React from "react";
import { Flex, Text } from "@chakra-ui/react";
import AppButton from "@/features/line-sheet-sets/app-button";
import PathPickFilterCountBadge from "@/features/pathpick/components/ui/PathPickFilterCountBadge";
import CustomIcon from "../../../../../public/icons-v1_1";
import useI18nHelper from "@/features/ui/hooks/use-i18n-helper";

interface Props {
  // 전체가 아닌 필터 축의 수. 0이면 배지를 띄우지 않는다.
  appliedCount: number;
  onClick: () => void;
  // 인라인 영역을 접었다 펴는 용도로 쓸 때만 넘긴다 — 넘기면 끝에 화살표가 붙는다.
  // 모달을 여는 쪽(PathPickRequestFilterModal.TriggerButton)은 넘기지 않아 모양이 그대로다.
  isExpanded?: boolean;
  // 옆 입력칸과 높이를 맞출 때만 넘긴다 — "auto"를 주고 부모 Flex를 stretch로 두면 입력칸 높이를 따라간다.
  // 미지정이면 AppButton 기본 높이(28px)다.
  height?: string;
}

// 모바일 전용 필터 버튼 — md 이상에서는 인라인 필터 줄이 그대로 보이므로 감춘다.
// AppButton은 Tooltip으로 감싸여 있어 display 분기는 바깥 Flex에 건다.
//
// 필터를 모달로 여는 화면(등록 신청 내역의 두 모달)과 카드 안에서 펼치는 화면
// (주문 내역)이 같은 버튼을 쓰도록 여기에 둔다.
function PathPickFilterToggleButton({
  appliedCount,
  onClick,
  isExpanded,
  height,
}: Props) {
  const { t } = useI18nHelper();

  return (
    <Flex display={{ base: "flex", md: "none" }}>
      <AppButton
        variant={"white"}
        isActive={appliedCount > 0}
        chakraProps={{ padding: "8px" }}
        height={height}
        onClick={onClick}
      >
        <Flex gap={"4px"} alignItems={"center"}>
          {/* filter.svg는 fill을 하드코딩해 color prop이 먹지 않는다. 흰 버튼 위 회색으로 쓴다. */}
          <CustomIcon src={"filter"} width={16} height={16} />
          <Text textStyle={"body-sm-bold"} whiteSpace={"nowrap"}>
            {t("path_pick:filter.title")}
          </Text>
          {appliedCount > 0 && (
            <PathPickFilterCountBadge label={String(appliedCount)} />
          )}
          {isExpanded !== undefined && (
            <CustomIcon
              src={isExpanded ? "chevron-up" : "chevron-down"}
              width={16}
              height={16}
            />
          )}
        </Flex>
      </AppButton>
    </Flex>
  );
}

export default PathPickFilterToggleButton;
